'use strict';

const tripTypeUtils = require('../modules/utils/trip_type');

function getTrackingValue(value1, value2) {
    return Odigeo._.isEqual(value1, value2) ? '0' : '1';
}

function getTrackingValueType(lastSearchType, currentSearchType) {
    return lastSearchType === currentSearchType ? '0' : tripTypeUtils.toAcronym(currentSearchType);
}

function getTrackingValueDate(lastSearch, currentSearch) {
    let date1;
    let date2;
    let diff = getTrackingValue(lastSearch, currentSearch);

    if (diff === '0') {
        return diff;
    }

    date1 = Odigeo.Utils.parseDate(lastSearch).getTime();
    date2 = Odigeo.Utils.parseDate(currentSearch).getTime();
    diff = Odigeo.Utils.getDifferenceInDays(date1, date2);

    return '1-' + (diff > 0 ? '+' + diff : diff);
}

function getPaxTrackingValue(lastSearch, currentSearch) {
    return (lastSearch.numAdults === currentSearch.numAdults) &&
    (lastSearch.numChildren === currentSearch.numChildren) &&
    (lastSearch.numInfants === currentSearch.numInfants) ? '0' : '1';
}

function changesInRequest(lastSearch, currentSearch) {
    const lastSearchSegments = lastSearch.searchSegments;
    const actualSearchSegments = currentSearch.searchSegments;
    const hasTypeChanged = currentSearch.type !== lastSearch.type;
    const orig = getTrackingValue(lastSearchSegments[0].departure, actualSearchSegments[0].departure);
    const des = getTrackingValue(lastSearchSegments[0].destination, actualSearchSegments[0].destination);
    const dep = getTrackingValueDate(lastSearchSegments[0].dateStr, actualSearchSegments[0].dateStr);
    const ret = (!hasTypeChanged && tripTypeUtils.isRoundTrip(currentSearch.type)) ?
        getTrackingValueDate(lastSearchSegments[1].dateStr, actualSearchSegments[1].dateStr) : '0';
    const tip = getTrackingValueType(lastSearch.type, currentSearch.type);
    const pax = getPaxTrackingValue(lastSearch, currentSearch);
    const direct = getTrackingValue(lastSearch.directFlightsOnly, currentSearch.directFlightsOnly);

    return 'change_search_orig:' + orig +
        '_dest:' + des +
        '_dep:' + dep +
        '_ret:' + ret +
        '_pax:' + pax +
        '_tip:' + tip +
        '_dir:' + direct;
}

module.exports = {
    changesInRequest: changesInRequest,
};
